import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-purchase-faq',
  templateUrl: './purchase-faq.component.html',
  styleUrls: ['./purchase-faq.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PurchaseFaqComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
